import { z } from 'zod';

export const EmployerDataZod = z.object({
    name: z.string(),
    domain: z.string(),
    imageLink: z.string(),
    discounter: z.boolean(),
});
export type EmployerData = z.infer<typeof EmployerDataZod>;

export const EmployeeCodeValidityResponseZod = z.object({ isValid: z.boolean() });
export type EmployeeCodeValidityResponse = z.infer<typeof EmployeeCodeValidityResponseZod>;
